import type { PlayerSeasonStatRow } from '../../../../services/player/playerSeasonStats'
import { MISSING_STAT } from '../constants'
import type { StatColumn } from '../types'
import {
  formatStatValue,
  getGamesPlayedAbbr,
  getStatValue,
  isDerivedStat,
  isRebuildableRate,
  rebuildRate,
  toStatNumber,
} from './statValues'

const sumStats = (rows: PlayerSeasonStatRow[]): Record<string, number> => {
  const sums: Record<string, number> = {}
  rows.forEach((row) => {
    const seen = new Set<string>()
    row.stats?.forEach((stat) => {
      const abbr = stat.abbr ?? stat.type?.abbr
      if (!abbr || seen.has(abbr)) {
        return
      }
      seen.add(abbr)
      const value = toStatNumber(getStatValue(row.stats, abbr))
      if (value !== null) {
        sums[abbr] = (sums[abbr] ?? 0) + value
      }
    })
  })
  return sums
}

export const buildCareerRow = (
  rows: PlayerSeasonStatRow[],
  columns: StatColumn[]
): Record<string, string> => {
  const sums = sumStats(rows)
  const games = sums[getGamesPlayedAbbr(columns.map((c) => c.abbr))] ?? 0

  return columns.reduce<Record<string, string>>((career, { abbr }) => {
    if (isRebuildableRate(abbr)) {
      career[abbr] = formatStatValue(rebuildRate(abbr, sums, games), abbr)
    } else if (isDerivedStat(abbr)) {
      career[abbr] = MISSING_STAT
    } else {
      career[abbr] = formatStatValue(sums[abbr] ?? null, abbr)
    }
    return career
  }, {})
}
